<app-alert-toast></app-alert-toast>
<router-outlet></router-outlet>
<app-page-spinner message="Loading..."></app-page-spinner>
